//
// Template store
//

import * as client from 'api/client';
import { template as templateSchema } from 'api/schema';
import { normalize } from 'normalizr';
import { LOGOUT } from './auth';

// ------------------------------------
// Constants
// ------------------------------------

export const NO_TEMPLATE = {
  id: 0,
  title: ''
};

// ------------------------------------
// Action definitions
// ------------------------------------

export const REQUEST_TEMPLATES = 'TEMPLATES/REQUEST';
export const RECEIVE_TEMPLATES = 'TEMPLATES/RECEIVE';

// ------------------------------------
// Actions
// ------------------------------------

export const fetchTemplates = () => dispatch => {
  dispatch({ type: REQUEST_TEMPLATES });

  return client.get('/api/public/templates')
    .then(json => {
      const { entities } = normalize(json, [ templateSchema ]);
      dispatch({
        type: RECEIVE_TEMPLATES,
        templates: entities.templates
      });
    })
    .catch(console.error);
};

// ------------------------------------
// Initial state
// ------------------------------------

const initialState = {
  items: {},
  pending: false
};

// ------------------------------------
// Reducer
// ------------------------------------

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_TEMPLATES:
      return {
        ...state,
        pending: true
      };

    case RECEIVE_TEMPLATES:
      return {
        ...state,
        items: action.templates,
        pending: false
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

// ------------------------------------
// Utils
// ------------------------------------

export const getAllTemplates = state => {
  return Object.values(state.templates.items);
};

export const getTemplate = (state, id) => {
  const { items } = state.templates;
  return items.hasOwnProperty(id)
    ? { ...items[id] }
    : null;
};



// WEBPACK FOOTER //
// ./src/store/modules/templates.js